<template>
  <div class="pro-manage-main">
    <div class="search-main">
      <el-form :inline="true" class="demo-form-inline">
        <el-form-item label="项目状态">
          <el-select v-model="params.statusNum" placeholder="项目状态" clearable @change="searchData">
            <el-option label="未完工" :value="0"></el-option>
            <el-option label="已完工" :value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="项目名称">
          <el-input v-model="params.name" placeholder="项目名称" clearable @change="searchData"></el-input>
        </el-form-item>
        <el-form-item style="margin-right: 20px">
          <el-button type="primary" icon="search" @click="searchData">查询</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="table-main">
      <el-table :data="projectTree" row-key="id" border height="calc(100% )">
        <el-table-column label="名称" min-width="250">
          <template #default="scope">
            <span v-if="scope.row.type == 'PROJECT'">
              <span>
                <span class="project-name-span" style=" background: #39a3ff;">项目</span>
                {{ scope.row.projectName }}
              </span>
            </span>
            <span v-else-if="scope.row.type == 'TEAM'">
              <span class="project-name-span" style=" background: #39ffbf;">施工队</span>
              {{ scope.row.teamName }}
            </span>
            <span v-else>
              <span class="project-name-span" style="background: #eef063;">班组</span>
              {{ scope.row.groupName }}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="statusName" label="状态" width="80"
          :formatter="(row, c, v) => (row.type === 'PROJECT' && !row.pid ? v : '')"
        />
        <el-table-column prop="userNum" label="人数" width="80" />
        <el-table-column prop="directorName" label="负责人" width="130" />
        <el-table-column prop="directorPhone" label="负责人电话" width="130" />
        <el-table-column prop="startUpTime" label="开始日期" width="120" />
        <el-table-column fixed="right" label="操作" width="80">
          <template #default="{row}">
            <el-button type="text" @click="toInfo(row)">详情</el-button>
          </template>
        </el-table-column>
      </el-table>

      <pro-info v-model="infoVisible" :rowData="rowData" />
    </div>
  </div>
</template>
<script>
import { getOrgProjectTree } from "@/api/sys/org";
import { defineComponent } from "vue";
import ProInfo from './Info.vue';

export default defineComponent({
  components: { ProInfo },
  props: {
    id: String,
    currColumnValue: Number
  },
  data() {
    return {
      loading: false,
      projectTree: [],
      rowData: {}, // 行数据
      infoVisible: false, // 显示详情
      params: {
        id: null,
        statusNum: null,
        name: null
      }
    }
  },
  mounted() {
    this.params.id = this.id;
  },
  methods: {
    getData() {
      this.loading = true;
      this.params.id = this.id;
      getOrgProjectTree(this.params).then(({data}) => {
        this.projectTree = data.data;
        this.loading = false;
      }).catch(_ => this.loading = false);
    },
    searchData() {
      this.getData();
    },
    toInfo(row) {
      this.rowData = row;
      this.infoVisible = true;
    }
  },
  watch: {
    currColumnValue(val) {
      if (val === 4) {
        this.getData();
      }
    }
  }
});
</script>

<style lang="scss" scoped>
.pro-manage-main {
  width: 100%;
  height: 100%;
  .search-main {
    padding: 10px;
    .el-form-item {
      margin-bottom: 0px;
    }
  }
  .table-main {
    padding: 10px;
    height: calc(100% - 130px);
    .project-name-span {
      padding: 5px 8px;
      font-size: 12px;
      font-weight: bold;
      color: white;
    }
  }
}
</style>